import { render } from "./Tag.vue?vue&type=template&id=b8108c4a&scoped=true&ts=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"

import "./Tag.vue?vue&type=style&index=0&id=b8108c4a&lang=scss"
import "./Tag.vue?vue&type=style&index=1&id=b8108c4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8108c4a"]])

export default __exports__